import "jquery/dist/jquery.min.js";
  import Endpoints from "@/config/ApiEndpoints.js";
  import Axios from "axios";
  import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
  import CheckFailures from '@/pages/vehicles/vehiclescheckfailures/vehiclescheckfailures.vue';
  import {
    CalendarView,
    CalendarViewHeader,
    CalendarMathMixin    
  } from "vue-simple-calendar";
  import Datepicker from "vuejs-datepicker";
  import { replace } from "feather-icons";
  import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
  var moment = require("moment");

  export default {
    components: {
      CalendarView,
      CalendarViewHeader,
      Datepicker,
      CheckFailures
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      region: function(data){
        return VehicleRegistrationRegion(data);
      }
    },
    data() {
      return {
        format: "dd-MM-yyyy",
        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        PopupLoader: false,
        ShowLoader: false,
        submitted: false,
        editForm:false,
        SaveData:false,
        SavingFile:false,
        ExemptPsv:true,
        TrailerId: 0,
        componentKey:0,
        Branches:{},
        NewTrailer: {
          branch_id:0,	
          vrm: "",
          make: "",
          model: "",
          trailer_type: "Curtain Sider",
          capacity: "",
          max_load_weight: "",
          unladen_weight: "",
          last_pmi_date: "",
          next_pmi_due: "",
          year:"",
          exempt_psv:true,
          chassis_no:"",
          ni_number:"",
        },
        file: "",
      };
    },
    validations: {
      NewTrailer: {
        vrm: { required },
      },
    },
    mounted() {
      this.TrailerId = this.$route.params.TrailerId;
      this.GetTrailerDetail();
      this.GetBranches();      
    },
    computed : {
      years () {
        const year = new Date().getFullYear()
        return Array.from({length: year - 1969}, (value, index) => 1970 + index)
      }
    },
    methods: {
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch: true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Branches = Response.data.records;
          }
        });
      },	
      SetTrailerType(type){
        this.NewTrailer.trailer_type=type;
      },
      SetExemptPSV(type){
        this.ExemptPsv = type;
        this.NewTrailer.exempt_psv=type;
        if(type){
          this.NewTrailer.psv_date='';
        }
      },
      SetPSVDate(){
        this.ExemptPsv = false;
        this.NewTrailer.exempt_psv= false;
      },
      GetTrailerDetail() {
        this.ShowLoader = true;
        Axios.post(Endpoints.Trailer.Get, {
          token: localStorage.getItem("token"),
          trailer_id: this.TrailerId,
        }).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.NewTrailer = Response.data.trailer;
            this.ExemptPsv = Response.data.trailer.exempt_psv;
            if(Response.data.trailer.exempt_psv && Response.data.trailer.exempt_psv != 0){
              this.NewTrailer.psv_date='';
            }
            if(!Response.data.trailer.exempt_psv){
              this.ExemptPsv= true;
            }
          }
        });
      },
      UpdateTrailer(type) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.SaveData = true;
        this.Saving = true;
        
        Axios.post(Endpoints.Trailer.Update, {
          token: localStorage.getItem("token"),
          ...this.NewTrailer,
        }).then((Response) => {
          this.Saving = false;
          this.SaveData = false;
          if (Response.data.success) {
            this.$emit("classUpdate");
            this.$swal
              .fire(type+" has been Updated Successfully", "", "success")
              .then(() => {
                  this.file = '';
                  this.CancelEditTrailerPage();
                  this.GetTrailerDetail();
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      UpdateTrailerData(type) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.SaveData = true;
        this.Saving = true;

        if(this.NewTrailer.vrm == ''){
          this.$swal.fire('Enter Trailer Reg ID', '', 'error').then(() => {});
        }else{
          if (this.$refs.file && this.$refs.file.files[0]) {
            this.SaveData = true;
            let formData = new FormData();
            formData.append('token', localStorage.getItem('token'));
            formData.append('storage_type', 'CFT');
            formData.append('file', this.file);
            formData.append('reg_id', this.NewTrailer.vrm);
            Axios.post(Endpoints.File.Upload, formData).then((Response) => {
              this.SaveData = false;
              if (Response.data.success == true) {
                  this.NewTrailer.image = Response.data.file;
                this.file = '';
                  this.UpdateTrailer(type);
              } else {
                this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
              }
            });
          }else{
            this.UpdateTrailer(type);
          }
        }
        
      },
      EditTrailerPage() {
        this.editForm = true;
      },
      CancelEditTrailerPage() {
        this.SaveData = false;
        this.editForm = false;
        this.GetTrailerDetail();
      },
    },
  };